import { Stack, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { HeaderStyled } from './styles';

export const CreatingFilesLoader = () => {
  const { translate } = useLocales();

  return (
    <Stack mb={3} width={1}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={0}
      >
        <HeaderStyled>
          <Iconify icon="eos-icons:loading" width={20} height={20} />
          <Typography variant="subtitle2">
            {translate('shared.ai_prompt.generating_image')}...
          </Typography>
        </HeaderStyled>
      </Stack>
    </Stack>
  );
};
